import React, { useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Chart } from "primereact/chart";
import type { WeeklyStationMetric } from "../../../types/kpiDashboard";

interface Props {
  visible: boolean;
  onHide: () => void;
  trend: WeeklyStationMetric[];
}

const StationsDetailDialog: React.FC<Props> = ({ visible, onHide, trend }) => {
  const chartData = useMemo(() => ({
    labels: trend.map((d) => d.period),
    datasets: [
      {
        label: "Inactive",
        data: trend.map((d) => d.inactive),
        backgroundColor: "#f87171",
        borderRadius: 3,
        stack: "stations",
      },
      {
        label: "Active",
        data: trend.map((d) => d.active),
        backgroundColor: "#22c55e",
        borderRadius: 3,
        stack: "stations",
      },
    ],
  }), [trend]);

  const chartOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 300 },
    interaction: { mode: "index" as const, intersect: false },
    plugins: {
      legend: {
        position: "top" as const,
        labels: { color: "#495057", font: { size: 13 }, padding: 16 },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#6c757d", font: { size: 11 } },
        grid: { color: "#f3f4f6" },
      },
      y: {
        stacked: true,
        min: 0,
        ticks: { color: "#6c757d" },
        grid: { color: "#f3f4f6" },
        title: { display: true, text: "Stations", color: "#6c757d" },
      },
    },
  }), []);

  return (
    <Dialog
      header="Active vs Inactive Stations"
      visible={visible}
      onHide={onHide}
      style={{ width: "90vw", maxWidth: "1100px" }}
      modal
      dismissableMask
    >
      <Chart
        type="bar"
        data={chartData}
        options={chartOptions}
        style={{ height: "460px" }}
      />
    </Dialog>
  );
};

export default StationsDetailDialog;
